module.exports = __webpack_public_path__ + "media/escudos/logo_maria_auxiliadora-d0f13be4.png";